// File: frontend/src/pages/SuperAdmin/components/common/DonutChart/index.js

import React from 'react';
import styles from './DonutChart.module.css';

const DonutChart = ({ 
  data, 
  valueKey = 'count', 
  colorFn, 
  centerValue, 
  centerLabel 
}) => {
  // Calculate total for percentages
  const total = Object.values(data).reduce((sum, item) => sum + (item[valueKey] || 0), 0);
  
  // Calculate segment positions
  const getSegmentStart = (index) => {
    let startPercentage = 0;
    let i = 0;
    
    for (const [key, value] of Object.entries(data)) {
      if (i >= index) break;
      startPercentage += ((value[valueKey] || 0) / total) * 100;
      i++;
    }
    
    return `${startPercentage}%`;
  };
  
  const getSegmentEnd = (index) => {
    let startPercentage = 0;
    let endPercentage = 0;
    let i = 0;
    
    for (const [key, value] of Object.entries(data)) {
      if (i > index) break;
      
      if (i < index) {
        startPercentage += ((value[valueKey] || 0) / total) * 100;
      }
      
      endPercentage = startPercentage + ((value[valueKey] || 0) / total) * 100;
      i++;
    }
    
    return `${endPercentage}%`;
  };
  
  return (
    <div className={styles.chartContainer}>
      <div className={styles.donutChart}>
        {Object.entries(data).map(([key, value], index) => (
          <div 
            key={key}
            className={styles.donutSegment}
            style={{
              '--segment-start': getSegmentStart(index),
              '--segment-end': getSegmentEnd(index),
              '--segment-color': colorFn ? colorFn(key) : 'var(--color-primary)'
            }}
          ></div>
        ))}
        <div className={styles.donutInner}>
          <span className={styles.donutValue}>{centerValue}</span>
          <span className={styles.donutLabel}>{centerLabel}</span>
        </div>
      </div>
      
      <div className={styles.legendContainer}>
        {Object.entries(data).map(([key, value]) => (
          <div className={styles.legendItem} key={key}>
            <div 
              className={styles.legendColor} 
              style={{ backgroundColor: colorFn ? colorFn(key) : 'var(--color-primary)' }}
            ></div>
            <div className={styles.legendLabel}>{key}</div>
            <div className={styles.legendValue}>{value[valueKey] || 0}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DonutChart;